module.exports = __webpack_public_path__ + "img/41.fa59df63.jpg";